import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject
} from "@angular/core";
import {
  ReportDesignItemSignature,
  ReportDesignItemSignatureConfig
} from "../../report-design-item";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { map } from "rxjs/operators";
import { getCustomerNominative } from "src/app/support/customer";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { lastValueFrom } from "rxjs";

@Component({
  selector: "snt-report-designer-signature",
  templateUrl: "report-designer-signature.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerSignatureComponent implements OnInit {
  @Input()
  item!: ReportDesignItemSignature;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignItemSignatureConfig> = new EventEmitter();

  formData: { user: string | undefined; align: string | undefined } = {
    user: undefined,
    align: undefined
  };

  userDataSource: DataSource;

  private readonly memberBackend = inject(MemberBackend);

  constructor() {
    this.userDataSource = new DataSource({
      store: new CustomStore({
        byKey: async (id: string) => {
          switch (id) {
            case "authors": {
              return {
                value: "authors",
                display: sntTranslate(marker("Autori"))
              };
            }
            case "current-user": {
              return {
                value: "current-user",
                display: sntTranslate(marker("Utente corrente"))
              };
            }
            default: {
              return lastValueFrom(
                this.memberBackend.load(id).pipe(
                  map((member) => ({
                    ...member,
                    display: getCustomerNominative(member),
                    value: member.id
                  }))
                )
              );
            }
          }
        },
        load: async () => {
          return lastValueFrom(
            this.memberBackend.listActiveAll().pipe(
              map((members) => members.filter((x) => !!x.user?.signature)),
              map((members) => [
                {
                  value: "authors",
                  display: sntTranslate(marker("Autori"))
                },
                {
                  value: "current-user",
                  display: sntTranslate(marker("Utente corrente"))
                },
                ...members.map((x) => ({
                  ...x,
                  display: getCustomerNominative(x),
                  value: x.id
                }))
              ])
            )
          );
        }
      })
    });
  }

  ngOnInit(): void {
    this.formData.user = this.item.config?.user || "";
    this.formData.align = this.item.config?.align || "left";
  }

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item.config,
      ...this.formData
    });
  }
}
